import React from "react";
import { ApplyTemplateToProps } from "../ApplyTemplateDropdown/index.types";
import { cls } from "app/utils";
import { useTranslation } from "react-i18next";

const ApplyTemplateToGroup = ({
  className,
  groupSelectModalHanlder,
}: ApplyTemplateToProps) => {
  const { t } = useTranslation();

  return (
    <div className={cls(className)} onClick={groupSelectModalHanlder}>
      <i className="ico ico-team" />
      <p>{t("Apply to Group")}</p>
    </div>
  );
};

export default ApplyTemplateToGroup;
